export var SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export var setActivePage = function setActivePage(payload) {
  return {
    type: SET_ACTIVE_PAGE,
    payload: payload
  };
};